import Box from "@mui/material/Box";
import type { LocationListItem } from "@/content/proxyLocations";

import MarketingFooter from "@/components/marketing/MarketingFooter";
import MarketingHeader from "@/components/marketing/MarketingHeader";
import MarketingShell from "@/components/marketing/MarketingShell";
import MarketingHead from "@/components/marketing/article/MarketingHead";
import { BAR_ROW, BAR_RULE } from "@/components/marketing/header/tokens";
import { WIDE } from "@/components/marketing/tokens";
import HeroSection from "./HeroSection";
import LocationSection from "./LocationSection";
import LogoMarquee from "./LogoMarquee";
import PremiumSection from "./PremiumSection";
import ProductSection from "./ProductSection";
import StickyFreeBar from "./StickyFreeBar";
import TrustpilotSection from "./TrustpilotSection";
import UseCaseSection from "./UseCaseSection";
import WhySection from "./WhySection";
import { HOME_HEAD } from "./homeContent";

/**
 * What the hero sits below, measured from the top of the viewport: 100px at
 * the wide step, 64px at every narrower one, the published card resting 10px
 * under the 54px bar all the way down.
 */
const CLEARANCE = { wide: 100, lg: 64, md: 64, sm: 64 };

/** `heroVideo` comes from the CMS; without one the page draws no video control. */
export default function HomePage({
  heroVideo = null,
  locations,
}: {
  heroVideo?: string | null;
  /** The head of the order, which the locations band lists. */
  locations: ReadonlyArray<LocationListItem>;
}) {
  return (
    <MarketingShell>
      <MarketingHead
        title={HOME_HEAD.title}
        description={HOME_HEAD.description}
        canonical={HOME_HEAD.canonical}
        shareImage={HOME_HEAD.shareImage}
      />
      <MarketingHeader />
      {/* The bar is fixed, so the page clears it in flow. */}
      <Box
        component="main"
        sx={{
          pt: `${BAR_ROW.mobile + BAR_RULE}px`,
          [WIDE]: { pt: `${BAR_ROW.desktop + BAR_RULE}px` },
        }}
      >
        <StickyFreeBar />
        <HeroSection clearance={CLEARANCE} heroVideo={heroVideo} />
        <LogoMarquee />
        <ProductSection />
        <LocationSection locations={locations} />
        <WhySection />
        <PremiumSection />
        <TrustpilotSection />
        <UseCaseSection />
      </Box>
      <MarketingFooter />
    </MarketingShell>
  );
}
